// extracted by mini-css-extract-plugin
export default {"content":"Wv9UI64g0wsXP4QefPIl","release-version":"KyBnWeG266XBeDOABOwc"};